export const LEGEND_THRESHOLDS = {
  // Pie, Donut, Rose
  pie: { h: 270, w: 265 },
  donut: { h: 270, w: 265 },
  rose: { h: 270, w: 265 },

  // Cartesian & Others
  multibar: { h: 255 },
  waterfall: { h: 255 },
  stackedBar: { h: 225 },
  common: { h: 210, w: 260 },
  line: { h: 210 },
  area: { h: 210 },
  scatter: { h: 210 },
  stackedArea: { h: 210 },
  horizontalBar: { h: 210 },
  // line, area, scatter, boxplot, horizontalBar, horizontalStacked

  // Specialized
  calendar: { h: 180 },
  heatmap: { h: 180 },
  funnel: { h: 200 },
  treemap: { h: 140 },
};

export const LABEL_THRESHOLDS = {
  // Pie Area
  pieArea: { h: 150, w: 220 }, // pie, donut, rose

  // Others
  funnel: { h: 140, w: 150 },
  gauge: { min: 250 },
  common: { h: 150 }, // bar, line, area, sankey, scatter, boxplot
};

export const AXIS_THRESHOLDS = {
  common: { h: 120 },
  gauge: { min: 250 },
};

export const MARGIN_THRESHOLDS = {
  compact: { h: 120 }, // Threshold below which charts use '90%' radius or minimal margins
};
